import React from "react"
import { HeroLead } from "trimble-terra"
import { Link } from "gatsby"
import formatPageLinks from "../formatPageLinks"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatThemePreset } from "../formatTheme"
import { formatRichTextTheme } from "../LayoutComponents/formatLayoutFunctions"

const FormatAndRenderLeadHero = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const contentItems = data?.heroLeadContent?.map(content => {
    const { eyebrow, header, subheader, description, media, buttons, theme, isHeaderBig } =
      content

    const formattedButtons = buttons?.map(button => {

      const formattedButton = formatPageLinks(
        button,
        locale,
        button?.url?.__typename,
        homepageSlug,
        currentSpaceId,
        siteIdentifier
      )
      return {
        ...button,
        label: formattedButton?.text,
        destination: formattedButton?.url,
        primary: button?.isPrimary,
        Link: Link,
      }
    })

    const presetTheme = formatThemePreset(theme)

    const formattedData = {
      eyebrow,
      header,
      subheader: subheader?.subheader,
      description: <RichTextConnector data={{ content: description }} />,
      buttons: formattedButtons,
      presetTheme: presetTheme,
      isWrapped: true,
      backgroundImage: null,
      video: null,
      isHeaderBig: isHeaderBig || false,
    }

    if (content?.media?.__typename === "ContentfulImageWithFocalPoint") {
      const backgroundImage = {
        title: media?.title,
        url: media?.image?.file?.url,
        x: media?.focalPoint?.focalPoint?.x,
        y: media?.focalPoint?.focalPoint?.y,
        height: media?.image?.file?.details?.image?.height,
        width: media?.image?.file?.details?.image?.width,
        altText: media?.altText ? media?.altText : "",
      }
      return {
        ...formattedData,
        backgroundImage,
        video: null,
      }
    } else if (content?.media?.__typename === "ContentfulVideo") {
      const video = {
        title: media?.title,
        src: media?.videoUrl,
      }
      return {
        ...formattedData,
        backgroundImage: null,
        video,
      }
    }
    return formattedData
  })

  const presetTheme = formatThemePreset(data?.bottomTheme)

  return (
    <HeroLead
      isWrapped={true}
      presetTheme={presetTheme}
      content={contentItems}
    />
  )
}

export default FormatAndRenderLeadHero
